export default "__VITE_ASSET__gi5lsd5F__"